
import { Box, Button, Menu, MenuItem, CircularProgress, IconButton, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Dispatch, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import RepeatRoundedIcon from "@mui/icons-material/RepeatRounded";
import { AgentShortcuts } from "../../../Shared-ui/Types/common";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Message } from "../../../Shared-ui/Types/PlayGround";


import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';


import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { useDispatch } from "react-redux";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { FEEDBACK_POST } from "../../../Services/Endpoint";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";




interface MyComponentProps {
  agentShortuts: any;
  messageId: number;
  sendMessageShortcuts: (shortcut: string, messageId: number) => void;
  incomingTextColor?: any;
  onToggleChart?: (messageId: number) => void;
  isChartable?: boolean;
  hasChart?: boolean;
  isChartVisible?: boolean;
  chartLoading?: boolean;
  messages: Message[]
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>
  agentId: string | undefined
  conversationId?: string
  responseId?: string
  apiKey?: string  // Optional API key for iframe authentication
  useApiKey?: boolean  // Flag to use API key instead of Bearer token
  hideRewrite?: boolean  // Flag to hide the rewrite button
  hideAllButtons?: boolean  // Flag to hide all action buttons (copy and feedback)
}

const AgentPrompts: React.FC<MyComponentProps> = (props) => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch()

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRewriteClick = (option: string) => {
    props.sendMessageShortcuts(option, props.messageId);
  };

  const test = (value: string) => {
    setActiveCategory(value);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveCategory(null);
  };


  const handleLikeMessage = () => {

    // props.setMessages(preVal => {
    // preVal[props.messageId].messageLike = true
    // return [...preVal]
    // })
    // console.log(props.messages[props.messageId])
  };




  const handleDisLikeMessage = () => {

    // props.setMessages(preVal => {
    // preVal[props.messageId].messageDisLike = true
    // return [...preVal]
    // })
    // console.log(props.messages[props.messageId])
  };

  const handleCopyMessage = async () => {
    if (props.messages[props.messageId]?.agentData?.rawResponse) {
      const rawRes = props.messages[props.messageId]?.agentData?.rawResponse;

      try {
        // Try using the Clipboard API first
        await navigator.clipboard.writeText(rawRes ? rawRes : "");
        dispatch(ShowSuccess("Copied to clipboard!"));
      } catch (err) {
        // Fallback for iframes where Clipboard API is blocked
        try {
          const textArea = document.createElement("textarea");
          textArea.value = rawRes ? rawRes : "";
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);

          if (!successful) {
            throw new Error('Copy command failed');
          }
          dispatch(ShowSuccess("Copied to clipboard!"));
        } catch (fallbackErr) {
          console.error('Failed to copy text:', fallbackErr);
          dispatch(ShowError("Failed to copy to clipboard"));
        }
      }
    }
  };

  const [alignment, setAlignment] = useState(null);

  const handleChangeLikeDisLike = async (event: any, newAlignment: any) => {
    // setAlignment(newAlignment);
    // You would typically send this 'newAlignment' to your backend here
    // setAlignment(newAlignment === alignment ? null : newAlignment);
    // let conversationId
    // props.setMessages(preVal => {
    //   conversationId = preVal[props.messageId].agentData?.conversation_id || ""
    //   return [...preVal]
    // })

    if (!props.agentId || !newAlignment || !props.conversationId) return

    const payload = {
      "agent_id": props.agentId,
      "conversation_id": props.conversationId,
      "response_id": props.responseId,
      "is_liked": JSON.parse(newAlignment)
    }

    try {
      dispatch(StartLoading());

      // Use fetch with API key for iframe context, BaseInstance for regular app
      if (props.useApiKey && props.apiKey) {
        // Iframe mode: use fetch with x-api-key header
        const response = await fetch(FEEDBACK_POST, {
          method: 'POST',
          headers: {
            'x-api-key': props.apiKey,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`Failed to submit feedback: ${response.statusText}`);
        }

        const data = await response.json();
      } else {
        // Regular app mode: use BaseInstance with Bearer token
        const data = await BaseInstance.post(FEEDBACK_POST, payload).then(
          (res) => res?.data
        );
      }

      props.setMessages(preVal => {
        preVal[props.messageId].isMessageLike = newAlignment
        return [...preVal]
      })

    } catch (err: any) {
      props.setMessages(preVal => {
        preVal[props.messageId].isMessageLike = null
        return [...preVal]
      })
      dispatch(ShowError(err?.message || 'Failed to submit feedback'));
    } finally {
      dispatch(StopLoading());
    }


  };

  return (
    <>
      {!props.hideAllButtons && (
        <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}>

          {/* feed back */}
          {/* <IconButton aria-label="like" onClick={handleLikeMessage} disabled={props.messages[props.messageId].messageLike}>
            <ThumbUpAltIcon />
          </IconButton>
          <IconButton aria-label="dislike" onClick={handleDisLikeMessage} disabled={props.messages[props.messageId].messageDisLike}>
            <ThumbDownAltIcon />
          </IconButton> */}
          <IconButton aria-label="dislike" onClick={handleCopyMessage}>
            <ContentCopyIcon />
          </IconButton>

          <ToggleButtonGroup
            value={props.messages[props.messageId].isMessageLike || null}
            exclusive
            onChange={handleChangeLikeDisLike}
            aria-label="like or dislike"
            sx={{
              border: 'none', // remove border around group
              '& .MuiToggleButtonGroup-grouped': {
                border: 'none', // remove borders between buttons
                margin: '0 4px',
                borderRadius: '3px',
              },
            }}
          >
            <ToggleButton value="true" aria-label="like">
              <ThumbUpIcon />
            </ToggleButton>
            <ToggleButton value="false" aria-label="dislike">
              <ThumbDownAltIcon />
            </ToggleButton>
          </ToggleButtonGroup>

          {!props.hideRewrite && (
            <Button
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleMoreClick(e);
              }}
              startIcon={
                <Box
                  sx={{
                    transform: "scaleX(-1)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <RepeatRoundedIcon fontSize="small" />
                </Box>
              }
              endIcon={<KeyboardArrowDownIcon />}
              sx={{
                minWidth: "auto",
                px: 2,
                py: 0.5,
                height: "32px",
                //border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "16px",
                textTransform: "none",
                color: props.incomingTextColor,
                fontSize: "0.875rem",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  color: "#02BEDB",
                },
              }}
            >
              Rewrite
            </Button>
          )}
          {props.isChartable !== false && (
            <Button
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (!props.chartLoading) {
                  props.onToggleChart && props.onToggleChart(props.messageId);
                }
              }}
              startIcon={
                props.chartLoading ? (
                  <CircularProgress size={16} sx={{ color: props.incomingTextColor }} />
                ) : (
                  <ShowChartIcon fontSize="small" />
                )
              }
              disabled={props.chartLoading || !props.isChartable}
              sx={{
                display: props.isChartable ? "flex" : "none",
                minWidth: "auto",
                px: 2,
                py: 0.5,
                height: "32px",
                borderRadius: "16px",
                textTransform: "none",
                color: props.incomingTextColor,
                fontSize: "0.875rem",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  color: "#02BEDB",
                },
                "&.Mui-disabled": {
                  opacity: 0.5,
                },
              }}
            >
              {props.chartLoading
                ? "Generating..."
                : props.isChartVisible
                  ? "Hide chart"
                  : "Show chart"}
            </Button>
          )}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right", // Align to button's right
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right", // Menu appears aligned to right
            }}
            sx={{
              "& .MuiPaper-root": {
                width: "auto", // Increased width to accommodate submenu
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                borderRadius: "12px",
                mt: .5,
                display: "flex",
                overflow: "visible",
              },
            }}
          >
            <Box
              sx={{
                width: "240px",
              }}
            >
              {props.agentShortuts?.categories &&
                props.agentShortuts?.categories?.map((category: string) => (
                  <Box key={category}>
                    <MenuItem
                      //onMouseEnter={() => test(category)}
                      onClick={() => setActiveCategory(activeCategory === category ? null : category)}
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        color: "text.secondary",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor:
                          activeCategory === category
                            ? "rgba(0,0,0,0.04)"
                            : "transparent",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      }}
                    >
                      {category}
                      <KeyboardArrowRightIcon sx={{ fontSize: 20 }} />
                    </MenuItem>
                    {activeCategory === category && (
                      <Box sx={{}}>
                        {props.agentShortuts.category_structure[
                          category as keyof typeof props.agentShortuts.category_structure
                        ]?.map((item: any) => (
                          <MenuItem
                            key={item.action}
                            onClick={() => {
                              handleRewriteClick(item.action);
                              handleMenuClose();
                            }}
                            sx={{
                              fontSize: "0.875rem",
                              pl: 4,
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                      </Box>
                    )}
                  </Box>
                ))}
            </Box>
          </Menu>
        </Box>
      )}
    </>
  );
};

export default AgentPrompts;
